<template>
    <div class="home">
        <!-- 公共头部 -->
       <common-top></common-top>
       <div class="content">
            <router-view ></router-view>
       </div>
       <!-- 公共底部 -->
       <common-bottom></common-bottom>
    </div>
</template>
<script>
import CommonTop from "../components/commontop"
import CommonBottom from "../components/commonbottom"
export default {
    components:{
       CommonTop,
       CommonBottom
    },
    data() {
        return {
        
        }
    },
    mounted(){  

    },
    created() {

    },
    methods:{
    }
}
</script>
<style lang="scss">
</style>
